export function slugify(string) {
	return string
		.toLowerCase() // Convert the string to lowercase
		.replace(/\s+/g, '-') // Replace spaces with hyphens
		.replace(/[^\w-]+/g, '') // Remove non-word characters (except hyphens)
		.replace(/--+/g, '-') // Replace consecutive hyphens with a single hyphen
		.replace(/^-+|-+$/g, '') // Trim hyphens from the beginning and end
}

export function destructureDate(dateString) {
	const date = new Date(dateString)

	const year = date.getFullYear()
	const monthNumber = date.getMonth() + 1
	const day = date.getDate()

	const monthName = date.toLocaleDateString(undefined, { month: 'long' })
	const dayName = date.toLocaleDateString(undefined, { weekday: 'long' })

	return {
		year,
		month: monthNumber,
		monthName,
		day,
		dayName,
	}
}

export function camelCaseToKebabCase(string) {
	return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

export function capitalizeFirstChar(string) {
	if (string.length === 0) {
		return string
	}

	return string.charAt(0).toUpperCase() + string.slice(1)
}

export function formatInteger(value, units = 2, cap = false) {
	const num = Number(value)
	const numDigits = String(num).length

	if (numDigits === units) {
		return String(num)
	} else if (numDigits < units) {
		return `${'0'.repeat(units - numDigits)}${num}`
	} else if (cap) {
		return '9'.repeat(units)
	}

	return String(num)
}

export function formatNumberThousands(number, separator = '.') {
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
}

export function conditionalClassnameBuilder(...fragments) {
	const classes = []

	for (let index = 0; index < fragments.length; index++) {
		const fragment = fragments[index]

		if (typeof fragment === 'string') {
			classes.push(fragment)
		}

		if (Array.isArray(fragment) && !!fragment[0]) {
			classes.push(fragment[1])
		}
	}

	return classes.filter((value) => typeof value === 'string').join(' ')
}

export function isValidEmail(email) {
	const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	return regex.test(email)
}

export function uuid() {
	let d = new Date().getTime() // timestamp
	let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0 // time in microseconds since page-load or 0 if unsupported

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		let r = Math.random() * 16 // random number between 0 and 16

		if (d > 0) {
			// use timestamp until depleted
			r = (d + r) % 16 | 0
			d = Math.floor(d / 16)
		} else {
			// use microseconds since page-load if supported
			r = (d2 + r) % 16 | 0
			d2 = Math.floor(d2 / 16)
		}
		return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
	})
}

// fast unique id
export function fuid() {
	const timestamp = (typeof performance !== 'undefined' && performance.now()) || 0
	const r = Math.random().toString().split('').splice(10, 4)

	const rh = Number(r.join('')).toString(32)
	const h = timestamp.toString(32)

	return `${rh}.${h}`.replace(/\./g, '_')
}
